'use client';

import { useTranslations } from 'next-intl';
import { ProductInfoTabParamsValue } from '@headless-workspace/domain/common/server';
import { GlowTextBody, PropsWithClassName, PropsWithFontFamily } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { DESCRIPTION_TAB_ID, ProductInfoCTA } from '../productInfoSection';

type ProductSeeDescriptionProps = PropsWithFontFamily & {
    productInfoTabParams: ProductInfoTabParamsValue[];
} & PropsWithClassName;

export const ProductSeeDescription: Component<ProductSeeDescriptionProps> = ({ productInfoTabParams, fontFamily }) => {
    const t = useTranslations('Discover.Pdp.productInfo.productTab.label');

    return (
        <ProductInfoCTA
            productTabs={productInfoTabParams}
            openTabWithId={DESCRIPTION_TAB_ID}
            labelElement={
                <GlowTextBody
                    text={t('seeDescription')}
                    fontFamily={fontFamily}
                    textDecoration={'underline'}
                    TagName={'span'}
                />
            }
            isHyperText={true}
            fontFamily={fontFamily}
        />
    );
};
